import { ReportBetMobileType } from "app/types/reportType";
import { isObject } from "lodash";
import BetBuilderReport from "../MultipleBetHeader/BetBuilderReport";
import MultipleBetHeader from "../MultipleBetHeader/MultipleBetHeader";
import "../Report.scss";
import ReportHeader from "../ReportHeader/ReportHeader";

type Props = {
  bet: ReportBetMobileType;
  eventName: string;
  contentType: string;
  placedScore: string | null;
  translatedBetType: string;
  betType: string;
};

const DisplayReportHeader: React.FC<Props> = props => {
  const {
    bet,
    contentType,
    eventName,
    placedScore,
    translatedBetType,
    betType,
  } = props;

  let sportName = bet?.sportName;
  // betType is sometimes a string and sometimes an object
  if (bet.betType && isObject(bet.betType) && bet.betType.betType === "Bet") {
    sportName = bet.betType.sport;
  }
  return (
    <>
      {betType === "Multiplier" && (
        <MultipleBetHeader
          multiplierName={bet.multiplierName}
          contentType={contentType}
          legs={bet.legs}
          submittedType={bet.submittedType}
        />
      )}
      {/* betType is "Betting" asian open bets panel",
      and Bet on euro open bets panel and mobile reports */}
      {(betType === "Bet" || betType === "Betting") && (
        <ReportHeader
          contentType={contentType}
          marketName={bet.marketName}
          runnerName={bet.runnerName}
          isUSPlayerProp={bet.isUSPlayerProp}
          eventName={eventName}
          placedScore={placedScore}
          sportName={sportName}
        />
      )}
      {betType === "Bet Builder" && (
        <BetBuilderReport
          multiplierName={bet.multiplierName}
          contentType={contentType}
          legs={bet.legs}
          submittedType={bet.submittedType}
          translatedBetType={translatedBetType}
          eventName={eventName}
          betType={betType}
        />
      )}
    </>
  );
};

export default DisplayReportHeader;
